import styled from "styled-components";

const Divider = styled.div`
  width: 100%;
  height: 1px;
  background: #f2f3f8;
  margin: 35px 0;
`;

export default Divider;
